import React from 'react';
import PropTypes from 'prop-types';
import { FormattedPlural } from 'react-intl';
import { Link } from 'react-router';

import { statusColours } from '../../constants/ColourConstants';
import ROLES from '../../constants/Roles';

import ContextIconMenu from '../Common/ContextIconMenu';
import { ListItem } from 'material-ui/List';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import UserGroupIcon from 'material-ui/svg-icons/social/people-outline';

import DepartmentActions from '../../actions/DepartmentActionCreator';


const getActions = (row) => [
    {
        link: `/dashboard/department/${row.id}`,
        label: 'Preview',
        icon: <InfoIcon />
    },
    {
        type:'divider'
    },
    {
        link: `/dashboard/department/${row.id}/edit`,
        label: 'Edit',
        icon: <EditIcon />,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete department',
        deleteAction: DepartmentActions.delete,
        message: (
            <span>Delete department  "{row.name}" ?</span>
        ),
        condition: {
            show:  row.sysStatus > 4,
            roles: [ROLES.ADMIN]
        }
    }
];


const style ={
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0
    },
    menuItem: {
        color: '#CC0000'
    },
    iconButton: {
        marginRight: 0
    },
    listItem: {
        padding: '2px'
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};


const DepartmentListItem = ({data, onDelete, actions }) => {


    const infoLink = `/dashboard/department/${data.id}`;
    let iconColor = data.userCount > 0 ? statusColours.primary : statusColours.disabled;

    const spot = data.isDefault ?  (<span className="spot" title="default"/>) : (null) ;

    const actionList = (actions || getActions(data));
    const rightIcon = (!!actionList && actionList.length > 0)
        ? (<ContextIconMenu actions={actionList} data={data}/>)
        : undefined;

    const listItemProps = {
        primaryText: (<Link to={infoLink} className="primaryText">{data.name}{spot}</Link>),
        secondaryTextLines: 2
    };
    let userCount;
    if (data.userCount !== undefined) {
        userCount = <span>{data.userCount}&nbsp;<FormattedPlural value={data.userCount} one='member' other='members' /></span>;
    }

    listItemProps.secondaryText = (
        <Link to={infoLink} className="secondaryText">
            {data.description}<br />
            {userCount}
        </Link>
    );

    return (
        <ListItem
            style={style.listItem}
            leftAvatar={
                <Link to={infoLink}>
                    <UserGroupIcon color={iconColor} style={style.icon} />
                </Link>
            }
            rightIcon={rightIcon}
            {...listItemProps}
        />
    );

};


DepartmentListItem.propTypes = {
    data: PropTypes.object.isRequired,
    actions: PropTypes.arrayOf(PropTypes.object),
    onDelete: PropTypes.func
};

export default DepartmentListItem;
